module.exports = __webpack_public_path__ + "assets/img/17.8c4a84b0.png";